import { render } from "./WarningModal.vue?vue&type=template&id=e23668f2&scoped=true"
import script from "./WarningModal.vue?vue&type=script&lang=js"
export * from "./WarningModal.vue?vue&type=script&lang=js"

import "./WarningModal.vue?vue&type=style&index=0&id=e23668f2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e23668f2"]])

export default __exports__